import { NgIfContext } from '@angular/common';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { AuthorizationModel } from '../models/authorization-model';


@Directive({
  selector: '[removeIfNoPermission]'
})
export class RemoveIfNoPermission {
  private hasView: boolean = false;
  constructor(private container: ViewContainerRef,
    private template: TemplateRef<any>,
    private authService: AuthService) { }

  @Input() set removeIfNoPermissionElse(elseTemplateRef: TemplateRef<NgIfContext> | null) {
    if (!this.hasView && elseTemplateRef) {
      this.container.createEmbeddedView(elseTemplateRef);
    }
  }

  @Input() set removeIfNoPermission(authModel: AuthorizationModel) {
    if (authModel == null || (typeof(authModel.roleUserType) !== 'undefined' && !authModel.roleUserType.length) && !authModel.role.length && !authModel.userType.length) {
      this.container.clear();
      this.hasView = false;
      return;
    }

    let hasRole = !!authModel.role.length && this.authService.hasRole(authModel.role);
    let hasUserType = this.authService.hasUserType(authModel.userType);
    let hasUserTypeRole = this.authService.hasUserTypeRole(authModel.roleUserType);
    let hasOrg = !authModel.authOrgCode || this.authService.hasOrgCode(authModel.authOrgCode) || this.authService.hasRole(['NESS Administrator']);

    if (hasOrg && (hasUserTypeRole || (hasUserType && hasRole)) && !this.hasView) {
      this.container.createEmbeddedView(this.template);
      this.hasView = true;
    } else if (hasOrg && (hasUserTypeRole || (hasUserType && hasRole)) && this.hasView) {
      this.container.createEmbeddedView(this.template);
      this.hasView = true;
    } else if (!hasUserTypeRole && (!hasRole && !hasUserType) && !hasOrg && this.hasView) {
      this.container.clear();
      this.hasView = false;
    } else {
      this.container.clear();
      this.hasView = false;
    }
  }
}
